import _ from "lodash";
import { isValuePresent } from "../../utils/builderUtils";

export const buildProgressStylesheet = (builder, device, cta, element) => {
    let options = { ...element.options };

    let outerWidth = "400";
    if (options["progress-outer-width"]) {
      outerWidth = options["progress-outer-width"];
    }

    const innerWidthOverride = isValuePresent(options["progress-inner-width"]) ? options["progress-inner-width"] : undefined;

    let innerWidth;
    if (options["progress-type"] == "static") {
      innerWidth = innerWidthOverride ?? "50";
    }

    let outerRadius = "";
    if (options["progress-outer-radius"] == "cf-not-rounded") {
      outerRadius = "0px";
    }
    if (options["progress-outer-radius"] == "cf-slightly-rounded") {
      outerRadius = "4px";
    }
    if (options["progress-outer-radius"] == "cf-fully-rounded") {
      outerRadius = "100px";
    }
    if (options["progress-outer-radius"] == "custom") {
      outerRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          outerRadius += `${
            _.isNil(options["progress-outer-radius-" + side]) == false
              ? options["progress-outer-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let boxShadow;

    if (options["box-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["box-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["box-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (element.options["box-shadow-horizontal-distance"]
          ? `${element.options["box-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-vertical-distance"]
          ? `${element.options["box-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-blur-radius"]
          ? `${element.options["box-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-spread-radius"]
          ? `${element.options["box-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-color"]
          ? element.options["box-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    // prettier-ignore
    const desktopStyles = 
`#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress {
  ${outerRadius ? 'border-radius: ' + outerRadius + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-outer {
  ${outerWidth ? 'max-width: ' + outerWidth + 'px !important;' : ''}
  ${options["progress-outer-background-color"] ? 'background: ' + options["progress-outer-background-color"] + ' !important;' : ''}
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
  ${outerRadius ? 'border-radius: ' + outerRadius + ' !important;' : ''}
  ${options["progress-border-style"] ? 'border-style: ' + options["progress-border-style"] + ' !important;' : ''}
  ${_.isNil(options["progress-border-width"]) == false ? 'border-width: ' + options["progress-border-width"] + 'px !important;' : ''}
  ${_.isNil(options["progress-border-width-left"]) == false ? 'border-left-width: ' + options["progress-border-width-left"] + 'px !important;' : ''}
  ${_.isNil(options["progress-border-width-right"]) == false ? 'border-right-width: ' + options["progress-border-width-right"] + 'px !important;' : ''}
  ${_.isNil(options["progress-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["progress-border-width-bottom"] + 'px !important;' : ''}
  ${_.isNil(options["progress-border-width-top"]) == false ? 'border-top-width: ' + options["progress-border-width-top"] + 'px !important;' : ''}
  ${options["progress-border-color"] ? 'border-color: ' + options["progress-border-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-inner {
  ${innerWidth !== undefined ? 'min-width: ' + innerWidth + '%;' : ''}
  ${innerWidth === undefined && innerWidthOverride !== undefined ? 'width: fit-content !important; min-width: ' + innerWidthOverride + '% !important;' : ''}
  ${element.options["progress-format"] !== "box" && options['progress-height'] ? 'min-height: ' + options['progress-height'] + 'px !important;' : ''}
  ${element.options["progress-format"] == "box" && options['progress-inner-padding'] ? 'padding: ' + options['progress-inner-padding'] + 'px !important;' : ''}
  ${options["progress-inner-background-color"] ? 'background: ' + options["progress-inner-background-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h1, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h2, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h3, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h4, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h5, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message p, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message span {
  ${options["progress-text-font"] ? 'font-family: ' + options["progress-text-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['progress-text-font-weight'] ? 'font-weight: ' + options['progress-text-font-weight'] + ' !important;' : ''}
  ${options["progress-text-color"] ? 'color: ' + options["progress-text-color"] + ' !important;' : ''} 
  ${options["progress-text-size"] ? 'font-size: ' + options["progress-text-size"] + 'px !important;' : ''}
}`;

    // prettier-ignore
    const mobileStyles = 
`/* mobile styles */
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-inner {
  ${element.options["progress-format"] == "line" && options['progress-height-mobile'] ? 'min-height: ' + options['progress-height-mobile'] + 'px !important;' : ''}
  ${element.options["progress-format"] == "box" && options['progress-inner-padding-mobile'] ? 'padding: ' + options['progress-inner-padding-mobile'] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h1, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h2, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h3, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h4, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message h5, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message p, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-progress-message span {
  ${options["progress-text-size-mobile"] ? 'font-size: ' + options["progress-text-size-mobile"] + 'px !important;' : ''}
}`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
